import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";
import type { ResponseGetSchollShifts, postBodySchollShifts } from "./interfaceSchollShifts";

export const getSchollShifts = async (year?: string, sede?: string, level?: string): Promise<ResponseGetSchollShifts[]> => {

    const queryParams = `${year ? `yearId=${year}` : ''}${sede ? `${year ? '&' : ''}campusId=${sede}` : ''}${level ? `${level ? '&' : ''}levelId=${level}` : ''}`;
    const url = `/school-shifts${queryParams ? `?${queryParams}` : ''}`;

    try {
        const data = await getApi(url);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetSchollShifts[];
    }
}

export const postSchollShifts = async (body: postBodySchollShifts): Promise<ResponseGetSchollShifts> => {
    try {
        const data = await postApi('/school-shifts', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetSchollShifts;
    }
}



export const patchSchollShifts = async (body: postBodySchollShifts, id?: number): Promise<ResponseGetSchollShifts> => {
    try {
        const data = await patchApi(`/school-shifts/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetSchollShifts;
    }
}


export const getSchollShiftsId = async (term?: number): Promise<ResponseGetSchollShifts> => {
    try {
        const data = await getApi(`/school-shifts/${term}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetSchollShifts;
    }
}




export const deleteSchollShifts = async (term: number): Promise<any> => {
    try {
        const data = await deleteApi(`/school-shifts/${term}`, term);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const postNewDebtsSchool = async(body: any): Promise<any> => {
    try {
        const data = await postApi('/school-request', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetSchollShifts;
    }
}